import { render, staticRenderFns } from "./FilterBaseInputNumber.vue?vue&type=template&id=381a1152"
import script from "./FilterBaseInputNumber.vue?vue&type=script&lang=ts"
export * from "./FilterBaseInputNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports